module.exports = __webpack_public_path__ + "img/gear-G-high_132x132.e82bd1e4.png";